window.GetJobAlertForm = function ($scope, CareerPortalDataBus, positionsDataService) {
    var self = this;
    var formName = "get-job-alert-form";
    var _protected = BaseForm.call(self, formName, $scope);


    self.jobTypes = [
        {code: "FULL_TIME", name: $filter("translate")("Full Time")},
        {code: "PART_TIME", name: $filter("translate")("Part Time")},
        // {code: "SEASONAL", name: $filter("translate")("seasonal ")},
        // {code: "ON_CALL", name: $filter("translate")("oncall")}
    ];

    self.data = { jobType: [], positions: [] };

    var previousData;
    var brandInfo;

    var loadBrandsList = function () {
        var brandType = brandInfo.settings && brandInfo.settings.job_alerts_allowed_brand_type;
        BrandAPI.getFlattedBrandsTree(self.brand.id, brandType, 0, 400, 'CAREER_PORTAL')
            .then(function (brandsList) {
                self.brands = brandsList.brands;
                self.data.brands = self.data.brands || [];

                for (var i in self.brands){
                    self.brands[i].external_business_name = self.brands[i].external_business_name || self.brands[i].name;
                }
                if (previousData) {
                    for (var i in self.brands) {
                        for (var j in previousData['brands']) {
                            if (previousData['brands'][j].id === self.brands[i].id) {
                                self.data.brands.push(self.brands[i]);
                            }
                        }
                    }
                }
            });
    };

    self.load = function (formData, prevData) {

        previousData = prevData;
        self.brand = formData.brand;
        self.positions = [];
        self.data.positions = [];
        self.source = formData.source;

        if (previousData && previousData['locations'].length) {
            self.data.location = 'CITIES';
        } else {
            self.data.location = 'BRANDS';
        }

        var promises = {
            subscriptionsSettings: SubscriptionAPI.getBrandSubscriptionsSettings(self.brand.id),
            brandBasicInfo: CareerPortalAPI.getBrandBasicInfo(self.brand.id)
        };

        $q.all(promises)
            .then(function (res) {
                var subscriptionSetting = res['subscriptionsSettings'];
                brandInfo = res['brandBasicInfo'];
                self.data.settings = brandInfo && brandInfo.settings;
                self.locationMode = subscriptionSetting.location_list_modes || [];
                self.data.location = self.locationMode.indexOf('BRANDS') === -1 ? 'CITIES' : 'BRANDS';
                if (self.source !== 'CUSTOM_JOB_SEARCH') {
                    loadBrandsList();
                }
                self.isGDPRServiceEnabled = self.checkGDPRService(brandInfo);
                if (self.isGDPRServiceEnabled) {
                    BrandAPI.getBrandGDPRDisclaimers(self.brand.id)
                        .then(function (disclaimers) {
                            self.disclaimers = disclaimers;
                            $scope.$evalAsync();
                        });
                }

                $scope.$evalAsync();
            });

        if (self.source !== 'CUSTOM_JOB_SEARCH') {
            BrandAPI.getBrandsCities(self.brand.id)
                .then(function (cities) {
                    self.locations = cities;
                    self.data.locations = self.data.locations || [];

                    if (previousData) {
                        for (var i in self.locations) {
                            for (var j in previousData['locations']) {
                                if (previousData['locations'][j].city === self.locations[i].name) {
                                    self.data.locations.push(self.locations[i]);
                                }
                            }
                        }
                    }
                });
        }

        //load positions
        positionsDataService.getActivePositionsFlat(false, self.brand.id).then(function (positions) {
            self.positions = [];
            var flatPositions = filterPositionsPerBrand(positions);
            var groupedPositions = _.groupBy(flatPositions, function (position) {
                return position.groupName
            })
            self.positions = Object.entries(groupedPositions).map(function ([key, value]) {
                return {label: key, items: value}
            })

            self.data.positions = self.data.positions || [];

            if (previousData) {
                for (var i in self.positions) {
                    for (var p in self.positions[i].items) {
                        for (var j in previousData['positions']) {
                            if (previousData['positions'][j].code === self.positions[i].items[p].code) {
                                self.data.positions.push(self.positions[i].items[p]);
                            }
                        }
                    }
                }
            } else if (formData.position_code) {
                for (var i in self.positions) {
                    for (var j in self.positions[i].items) {
                        if (formData.position_code == self.positions[i].items[j].code) {
                            self.data.positions.push(self.positions[i].items[j]);
                            break;
                        }
                    }
                }
            }

        });

        if (previousData) {

            self.alreadyLoaded = true;

            for (var i in self.jobTypes) {
                for (var j in previousData['timings']) {
                    if (previousData['timings'][j] === self.jobTypes[i].code) {
                        self.data.jobType.push(self.jobTypes[i]);
                    }
                }
            }
        }
    };

    self.checkGDPRService = function (brandInfo) {
        return self.source === 'CUSTOM_JOB_SEARCH' ? (brandInfo.public_services && brandInfo.public_services.indexOf("GDPR") > -1) :
            (self.brand.public_services && self.brand.public_services.indexOf("GDPR") > -1);
    }

    self.resendPreferences = function () {
        SubscriptionAPI.sendPreferences(self.brand.id,  self.data.email)
            .then(function () {
                $scope.preferencesSent = true;
                $scope.$digest();
            })
    };

    self.save = function (brandId) {
        var defer = $q.defer();
        var payload = {
            email: self.data.email,
            base_brand_id: brandId,
            brands: self.data.location == "BRANDS" ?  (self.data.brands || []) : [],
            locations : self.data.location == "CITIES" ? (self.data.locations || []) : [],
            positions: self.data.positions || [],
            timings: []
        };

        for (var i in self.data.jobType) {
            payload['timings'].push(self.data.jobType[i]['code']);
        }

        if (!previousData) {
            SubscriptionAPI.submitJobAlertSubscription(payload)
                .then(function(data){
                    defer.resolve(data);
                }, function (err) {
                    defer.reject(err);
                });
        } else {
            SubscriptionAPI.updateJobAlertSubscription(previousData.id, $scope.token, payload)
                .then(function (data) {
                    defer.resolve(data);
                }, function (err) {
                    hAlert($filter("translate")("Error"), $filter("translate")("Invalid token."));
                    defer.reject(err);
                });
        }

        return defer.promise;
    };

    self.validator.validateCustom = function (field, optionsField, rule, showError, callback) {

        var name = field.attr("name");
        var value = self.validator.getFieldValue(field);

        switch (rule.name) {
            case "emailSubscribed":

                SubscriptionAPI.checkEmailSubscribed(self.brand.id, value)
                    .then(function (data) {
                        if (data.status && data.status != 'PENDING' && data.status != 'INACTIVE') {
                            callback(false);
                        } else {
                            callback(true);
                        }
                    }, function () {
                        callback(false);
                    });
                break;
        }
    };

    var filterPositionsPerBrand = function (positions) {
        var filteredPositions = [];

        for (var i in positions) {
            switch (self.brand.id) {
                case 998656: // M&B mbcareers-corporate
                    var position = angular.copy(positions[i]);
                    switch (positions[i].id) {
                        case 2846:
                            position.name = "Area Management";
                            filteredPositions.push(position);
                            break;
                        case 2854:
                            position.name = "Commercial";
                            filteredPositions.push(position);
                            break;
                        case 2851:
                            position.name = "Finance";
                            filteredPositions.push(position);
                            break;
                        case 2848:
                            position.name = "Human Resources";
                            filteredPositions.push(position);
                            break;
                        case 2850:
                            position.name = "IT";
                            filteredPositions.push(position);
                            break;
                        case 2849:
                            position.name = "Legal";
                            filteredPositions.push(position);
                            break;
                        case 573:
                            position.name = "Marketing";
                            filteredPositions.push(position);
                            break;
                        case 2847:
                            position.name = "Operations Management";
                            filteredPositions.push(position);
                            break;
                        case 2852:
                            position.name = "Procurement";
                            filteredPositions.push(position);
                            break;
                        case 2853:
                            position.name = "Property";
                            filteredPositions.push(position);
                            break;
                    }
                    break;
                case 1201128: // M&B mbcareers-management
                    var position = angular.copy(positions[i]);
                    switch (positions[i].id) {
                        case 28:
                            position.name = "General Manager";
                            filteredPositions.push(position);
                            break;
                        case 2769:
                            position.name = "General Manager Designate";
                            filteredPositions.push(position);
                            break;
                        case 2770:
                            position.name = "Kitchen Manager / Head Chef";
                            filteredPositions.push(position);
                            break;
                        case 2773:
                            position.name = "Kitchen Manager / Head Chef Designate";
                            filteredPositions.push(position);
                            break;
                        case 2772:
                            position.name = "Sales and Events Manager";
                            filteredPositions.push(position);
                            break;
                    }
                    break;

                case 1000215: // M&B mbcareers-team-member
                    var position = angular.copy(positions[i]);
                    switch (positions[i].id) {
                        case 30:
                            position.name = "Assistant Manager";
                            filteredPositions.push(position);
                            break;
                        case 2839:
                            position.name = "Bar Staff";
                            filteredPositions.push(position);
                            break;
                        case 264:
                            position.name = "Chef";
                            filteredPositions.push(position);
                            break;
                        case 2218:
                            position.name = "Cleaner";
                            filteredPositions.push(position);
                            break;
                        case 8:
                            position.name = "Host";
                            filteredPositions.push(position);
                            break;
                        case 2780:
                            position.name = "Kitchen Assistant";
                            filteredPositions.push(position);
                            break;
                        case 2642:
                            position.name = "Kitchen Lead";
                            filteredPositions.push(position);
                            break;
                        case 2201:
                            position.name = "Night Porter";
                            filteredPositions.push(position);
                            break;
                        case 2109:
                            position.name = "Room Attendant";
                            filteredPositions.push(position);
                            break;
                        case 27:
                            position.name = "Shift Supervisor";
                            filteredPositions.push(position);
                            break;
                        case 2564:
                            position.name = "Soft Play Team Member";
                            filteredPositions.push(position);
                            break;
                        case 16:
                            position.name = "Sous Chef";
                            filteredPositions.push(position);
                            break;
                        case 2838:
                            position.name = "Waiting Staff";
                            filteredPositions.push(position);
                            break;
                    }
                    break;

                default:
                    filteredPositions.push(positions[i]);
            }
        }

        return filteredPositions;
    };
};
